var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconId(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#0B966B",
    fillRule: "nonzero",
    cx: 8.125,
    cy: 9.231,
    rx: 1.625,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 12.308c1.795 0 3.25 1.377 3.25 3.077h-6.5c0-1.7 1.455-3.077 3.25-3.077z",
    fill: "#0B966B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.813 10h6.5M15.438 13.615h4.874M23.563.77h-3.25v.768c0 1.275-1.092 2.308-2.438 2.308s-2.438-1.033-2.438-2.308V.77h-4.874v.77c0 1.274-1.092 2.307-2.438 2.307S5.687 2.813 5.687 1.538V.77h-3.25C1.54.77.813 1.458.813 2.308v15.384c0 .85.727 1.539 1.625 1.539h21.125c.897 0 1.625-.689 1.625-1.539V2.308c0-.85-.728-1.539-1.625-1.539z",
    stroke: "#0B966B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgIconId;